<template>
  <div>
    <card>
      <div slot="header" class="clearfix">
        <b>{{ $t("app.modules.users.headers.list") }}</b>
      </div>

      <el-table stripe style="width: 100%" :data="queriedData">
        <el-table-column
          prop="nombre"
          :label="this.$t('app.modules.users.headers.name')"
          sortable
          width="220"
        >
        </el-table-column>
        <el-table-column
          prop="correo"
          :label="this.$t('app.modules.users.headers.mail')"
          sortable
          min-width="250"
        >
        </el-table-column>
        <el-table-column
          :label="this.$t('app.modules.users.headers.role')"
          sortable
          width="220"
        >
          <template slot-scope="props">{{ props.row.rols[0].nombre }}</template>
        </el-table-column>
        <el-table-column
          :label="$t('app.modules.messages.headers.state')"
          width="150"
        >
          <template slot-scope="props">
            <n-switch
              v-model="props.row.activo"
              @input="active(props.row)"
              color="black"
            >
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </el-table-column>

        <el-table-column
          :minWidth="200"
          className="is-center"
          labelClassName="is-center">

          <div slot-scope="scope" class="table-actions dropdown">
            <el-popover
              placement="bottom"
              width="250"
              trigger="click"
            >

              <div class="row">
                <div class="col-12 options">
                  <n-button
                    class="options-button"
                    type="primary"
                    @click.native="edit(scope.row)"
                    size="sm">
                    {{ $t('app.buttons.edit') }}
                  </n-button>
                </div>
              </div>

              <n-button
                slot="reference"
                size="sm"
                icon
                style="background-color:white;">
                <i class="fa fa-ellipsis-v" style="color:black;"></i>
              </n-button>

            </el-popover>
          </div>
        </el-table-column>

      </el-table>

      <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>

    </card>
  </div>
</template>

<script>
import {getResponse} from "@/util/utilities";

export default {
  name: "listaUsuarios",
  computed: {
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
      /*let searchedData = this.applyFilters(this.tableData);
      return searchedData.length > 0
        ? searchedData.length
        : this.tableData.length;*/
    }
  },
  data() {
    return {
      tableData: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
    }
  },
  mounted() {
    this.loadUsuarios();

    EventBus.$on("update-list", () => {
      this.loadUsuarios();
    });
  },
  methods: {
    async loadUsuarios(){
      let request = await this.$http.post(route("Usuarios/getUsuariosByClienteSAP"), {claveIdioma: this.$store.state.lang});
      let response = getResponse(request, null);

      if(response){
        this.tableData = response.usuarios;
      }
    },
    async active(row) {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      let request = await this.$http.put(route("Usuarios/updateUser"), row);
      let response = getResponse(request, null);

      if(response){
        this.notifyMessage("success", this.$t("app.promps.save_success"));
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));

      this.$swal.close();
    },
    edit(row){
      EventBus.$emit("edit-user", row);
    }
  }
}
</script>

<style scoped>

</style>
